// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__D0xtn","title":"styles_title__xzka1","message":"styles_message__u1sO+"};